module.exports = __webpack_public_path__ + "img/20200610_154844.7dc91c7e.jpg";